import React from 'react';
import LaboratoryDashboard from './LaboratoryDashboard';
import SAAAnalystDashboard from '../dashboards/SAAAnalystDashboard';
import SAASupervisorDashboard from '../dashboards/SAASupervisorDashboard';

interface SAALaboratoryDashboardProps {
  userRole: 'ANALYSTE' | 'TECHNICIEN' | 'SUPERVISEUR';
  userId: string;
}

const SAALaboratoryDashboard: React.FC<SAALaboratoryDashboardProps> = ({
  userRole,
  userId,
}) => {
  // Use comprehensive SAA analyst dashboard for analysts
  if (userRole === 'ANALYSTE') {
    return <SAAAnalystDashboard />;
  }

  // Use comprehensive SAA supervisor dashboard for supervisors
  if (userRole === 'SUPERVISEUR') {
    return <SAASupervisorDashboard />;
  }

  // Use generic laboratory dashboard for technicians
  return (
    <LaboratoryDashboard
      laboratoryType="SAA"
      laboratoryName="Laboratoire SAA (Aqua Regia)"
      userRole={userRole}
      userId={userId}
    />
  );
};

export default SAALaboratoryDashboard; 